import { BaseModel } from '../../_base/crud';

export class Prescription extends BaseModel {
  id: number;
  days_supply: number;
  drug: any;
  doctor: any;
  diagnosis_code: string;
  icd10: string;
  refill: string;
  sig: string;
  quantity: number;
  expiry_date: any;
  prescribe_date: any;
  stop_date: any;
  pms_rx_number: any;
  note: string;
  last_filled_date: any;
  hold_note: any;
  is_hold: boolean;
  is_active: boolean;
  prescription_id: string;
}
